import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import SurveySectionForm from "@/features/survey/form";
import { useSurveyPermissions } from "@/features/survey/hooks/useSurveyPermissions";
import { useOrganizationId } from "@/shared/hooks/useOrganizationId";
import { useGetSurveyByIdQuery } from "@/redux/service";
import { skipToken } from "@reduxjs/toolkit/query";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

const SurveySection = () => {
  const { surveyId, sectionId } = useParams();
  const [searchParams] = useSearchParams();

  const sampleOrganizationId = searchParams.get("sampleOrganizationId");
  const currentOrganizationId = useOrganizationId();
  const { data: survey, isError } = useGetSurveyByIdQuery(
    surveyId
      ? {
          surveyId,
          filters: {
            organization: sampleOrganizationId || currentOrganizationId,
          },
        }
      : skipToken,
  );
  const currentUser = useSelector(selectCurrentUser);
  const {
    canView,
    canEdit,
    isLoading: isLoadingPermissions,
  } = useSurveyPermissions(survey, currentUser);

  if (!surveyId || !sectionId) {
    return <Navigate to={"/"} />;
  }

  if (!survey || isLoadingPermissions || !currentUser) {
    return (
      <div className="flex justify-center full-width">
        <BaseSpinner />
      </div>
    );
  }

  if (isError || !canView) {
    return <Navigate to="/" />;
  }

  if (canEdit || sampleOrganizationId) {
    return (
      <SurveySectionForm
        surveyId={parseInt(surveyId)}
        sectionId={parseInt(sectionId)}
      />
    );
  }

  return <Navigate to={`/reports/${survey.id}/overview`} />;
};

export default SurveySection;
